var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_756_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9587 27.9993C18.076 27.9993 14.917 24.8403 14.917 20.9577C14.917 17.075 18.076 13.916 21.9587 13.916C25.8413 13.916 29.0003 17.075 29.0003 20.9577C29.0003 24.8403 25.8413 27.9993 21.9587 27.9993ZM21.9587 15.541C18.9719 15.541 16.542 17.9709 16.542 20.9577C16.542 23.9444 18.9719 26.3743 21.9587 26.3743C24.9454 26.3743 27.3753 23.9444 27.3753 20.9577C27.3753 17.9709 24.9454 15.541 21.9587 15.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.958 24.7493C21.5095 24.7493 21.1455 24.3853 21.1455 23.9368V17.9785C21.1455 17.53 21.5095 17.166 21.958 17.166C22.4065 17.166 22.7705 17.53 22.7705 17.9785V23.9368C22.7705 24.3853 22.4065 24.7493 21.958 24.7493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9378 21.7715H18.9795C18.531 21.7715 18.167 21.4075 18.167 20.959C18.167 20.5105 18.531 20.1465 18.9795 20.1465H24.9378C25.3863 20.1465 25.7503 20.5105 25.7503 20.959C25.7503 21.4075 25.3863 21.7715 24.9378 21.7715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9558 24.75H5.97917C4.33575 24.75 3 23.4143 3 21.7708V4.97917C3 3.33575 4.33575 2 5.97917 2H18.4375C20.0809 2 21.4167 3.33575 21.4167 4.97917V11.5767C21.4167 12.0252 21.0527 12.3892 20.6042 12.3892C20.1557 12.3892 19.7917 12.0252 19.7917 11.5767V4.97917C19.7917 4.23275 19.1839 3.625 18.4375 3.625H5.97917C5.23275 3.625 4.625 4.23275 4.625 4.97917V21.7708C4.625 22.5173 5.23275 23.125 5.97917 23.125H12.9558C13.4043 23.125 13.7683 23.489 13.7683 23.9375C13.7683 24.386 13.4043 24.75 12.9558 24.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3542 12.291H7.0625C6.614 12.291 6.25 11.927 6.25 11.4785C6.25 11.03 6.614 10.666 7.0625 10.666H17.3542C17.8027 10.666 18.1667 11.03 18.1667 11.4785C18.1667 11.927 17.8027 12.291 17.3542 12.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0208 16.625H7.0625C6.614 16.625 6.25 16.261 6.25 15.8125C6.25 15.364 6.614 15 7.0625 15H13.0208C13.4693 15 13.8333 15.364 13.8333 15.8125C13.8333 16.261 13.4693 16.625 13.0208 16.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 7.95898H7.0625C6.614 7.95898 6.25 7.59498 6.25 7.14648C6.25 6.69798 6.614 6.33398 7.0625 6.33398H11.9375C12.386 6.33398 12.75 6.69798 12.75 7.14648C12.75 7.59498 12.386 7.95898 11.9375 7.95898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_756_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToList);
export default __webpack_public_path__ + "static/media/AddToList.88c0fddf6e06260c406910d5646bbbcb.svg";
export { ForwardRef as ReactComponent };